import { useEffect } from 'react';

interface HotjarProps {
    siteId: string;
}

export const Hotjar = ({ siteId }: HotjarProps) => {
    useEffect(() => {
        if (typeof window === 'undefined' || !siteId) return;

        // Hotjar tracking code
        (function (h: any, o: any, t: any, j: any, a: any, r: any) {
            h.hj = h.hj || function () {
                (h.hj.q = h.hj.q || []).push(arguments);
            };
            h._hjSettings = { hjid: siteId, hjsv: 6 };
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script');
            r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

        // Cleanup function (optional)
        return () => {
            // Hotjar doesn't provide a cleanup method, but we can remove the script if needed
            const hotjarScript = document.querySelector('script[src*="hotjar"]');
            if (hotjarScript) {
                hotjarScript.remove();
            }
        };
    }, [siteId]);

    return null; // This component doesn't render anything
};

export default Hotjar;
